<script lang="ts">
  /* ConsentText — «I have read and accept the {terms} and the {privacy}» with
     the two placeholders rendered as links that open the documents in a new
     tab (the reader is mid-form; navigating away would lose their input).
     The documents themselves are English only. */
  import { _ } from "svelte-i18n";

  // Split the translated sentence around its placeholders, keeping them.
  const parts = $derived($_("consent.agree").split(/(\{terms\}|\{privacy\})/));
</script>

<span class="consent-text">
  {#each parts as part, i (i)}
    {#if part === "{terms}"}
      <a href="#/terms" target="_blank" rel="noopener">{$_("consent.terms")}</a>
    {:else if part === "{privacy}"}
      <a href="#/privacy" target="_blank" rel="noopener">{$_("consent.privacy")}</a>
    {:else}{part}{/if}
  {/each}
</span>

<style>
  .consent-text a { color: var(--color-primary); text-decoration: underline; text-underline-offset: 2px; }
</style>
